import { CommandGetSpendAccount } from "./commands/cmdGetSpendAccount";
import { CommandCreateSpendAccount, SpendAccountPayload } from "./commands/cmdCreateSpendAccount";
import { CommandUpdateSpendAccount } from "./commands/cmdUpdateSpendAccount";
import { CommandDeleteSpendAccount } from "./commands/cmdDeleteSpendAccount";
import { CommandGetBalance, ContractBalance } from "./commands/cmdGetBalance";
import { SpendAccount } from "@models/spendaccount.model";

export class SpendAccountService {
  async get(contractId: number): Promise<SpendAccount | null> {
    try {
      return await new CommandGetSpendAccount().run(contractId);
    } catch (error) {
      // A contract may not have a spend account yet — treat as absent, not fatal.
      console.error(`Failed to fetch spend account for contract ${contractId}:`, error);
      return null;
    }
  }

  async create(contractId: number, payload: SpendAccountPayload): Promise<SpendAccount> {
    try {
      return await new CommandCreateSpendAccount().run(contractId, payload);
    } catch (error) {
      console.error(`Failed to create spend account for contract ${contractId}:`, error);
      throw error;
    }
  }

  async update(contractId: number, payload: SpendAccountPayload): Promise<SpendAccount> {
    try {
      return await new CommandUpdateSpendAccount().run(contractId, payload);
    } catch (error) {
      console.error(`Failed to update spend account for contract ${contractId}:`, error);
      throw error;
    }
  }

  async delete(contractId: number): Promise<SpendAccount> {
    try {
      return await new CommandDeleteSpendAccount().run(contractId);
    } catch (error) {
      console.error(`Failed to delete spend account for contract ${contractId}:`, error);
      throw error;
    }
  }

  async getBalance(contractId: number): Promise<ContractBalance | null> {
    try {
      return await new CommandGetBalance().run(contractId);
    } catch (error) {
      console.error(`Failed to fetch balance for contract ${contractId}:`, error);
      return null;
    }
  }
}
